import { useEffect, useRef, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { FiArrowRight, FiDownload } from "react-icons/fi";
import { profile } from "../../data/portfolio";
import styles from "./Home.module.css";

const highlights = [
  "AI-driven products",
  "Real-time systems",
  "Cross-platform apps",
  "Full-stack delivery",
];

export default function Home() {
  const [active, setActive] = useState(0);
  const visualRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((i) => (i + 1) % highlights.length);
    }, 2600);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const el = visualRef.current;
    if (!el || window.matchMedia("(pointer: coarse)").matches) return;

    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      el.style.setProperty("--tx", `${x * 10}px`);
      el.style.setProperty("--ty", `${y * 8}px`);
    };

    const onLeave = () => {
      el.style.setProperty("--tx", "0px");
      el.style.setProperty("--ty", "0px");
    };

    el.addEventListener("mousemove", onMove);
    el.addEventListener("mouseleave", onLeave);
    return () => {
      el.removeEventListener("mousemove", onMove);
      el.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  return (
    <section id="home" className={styles.hero}>
      <div className={styles.ambient} aria-hidden="true">
        <span className={styles.orbOne} />
        <span className={styles.orbTwo} />
      </div>

      <p className={styles.watermark} aria-hidden="true">
        BRO
      </p>

      <div className={styles.inner}>
        <div className={styles.copy}>
          <div className={styles.kicker}>
            <span className={styles.pulse} />
            Available for full-time roles
          </div>

          <h1 className={styles.name}>
            Barsa Rani <span className={styles.accentName}>Ojha</span>
          </h1>

          <p className={styles.titleRow}>
            <span className={styles.title}>{profile.title}</span>
            <span className={styles.dot} aria-hidden="true" />
            <span className={styles.highlight} key={active}>
              {highlights[active]}
            </span>
          </p>

          <p className={styles.tagline}>
            {profile.experience} shipping polished web &amp; mobile experiences with React,
            Next.js, React Native, Node.js, MongoDB, and PostgreSQL.
          </p>

          <div className={styles.actions}>
            <Link smooth to="#projects" className={styles.primary}>
              View selected work <FiArrowRight />
            </Link>
            <a className={styles.secondary} href={profile.links.resume} download="Barsa_Rani_Ojha_Resume">
              Download resume <FiDownload />
            </a>
          </div>
        </div>

        <div className={styles.visual} ref={visualRef}>
          <div className={styles.accentPlane} aria-hidden="true" />
          <div className={styles.ring} aria-hidden="true" />
          <div className={styles.frame}>
            <img src="./Barsu.png" alt={profile.name} className={styles.photo} />
          </div>
          <div className={styles.caption}>
            <span>React · Next · RN</span>
            <span>Node.js · MongoDB · Postgres</span>
          </div>
        </div>
      </div>
    </section>
  );
}
